import t from 'vivino-js/translationString';
import { Allergens } from 'vivino-ui/icons/WineFacts';

const TRANSLATION_PATH = 'components.shared.wine_summary';
const TRANSLATIONS = {
  allergens: `${TRANSLATION_PATH}.allergens`,
  contains: `${TRANSLATION_PATH}.contains`,
  contains_egg_allergens: `${TRANSLATION_PATH}.contains_egg_allergens`,
  contains_milk_allergens: `${TRANSLATION_PATH}.contains_milk_allergens`,
  contains_added_sulfites: `${TRANSLATION_PATH}.contains_added_sulfites`,
  delimiter: `${TRANSLATION_PATH}.delimiter`,
};

const ALLERGENS_ADDED_SULFITES = 'contains_added_sulfites';
const ALLERGENS_KEYS = [
  ALLERGENS_ADDED_SULFITES,
  'contains_egg_allergens',
  'contains_milk_allergens',
];

export const getAllergensFact = (vintage, translationFunc = t) => {
  const wineFacts = vintage?.wine_facts || {};
  const allergens = ALLERGENS_KEYS.reduce((memo, key) => {
    if (key === ALLERGENS_ADDED_SULFITES || wineFacts[key]) {
      // add ALLERGENS_ADDED_SULFITES regardless of wine_facts value
      // because it is a legal requirement
      if (memo.length > 0) {
        memo += translationFunc(TRANSLATIONS.delimiter);
      }
      memo += translationFunc(TRANSLATIONS[key]);
    }
    return memo;
  }, '');
  return {
    key: 'allergens',
    headerLabel: translationFunc(TRANSLATIONS.allergens),
    icon: Allergens,
    values: [{ name: translationFunc(TRANSLATIONS.contains, { allergens }) }],
  };
};
